import { render, staticRenderFns } from "./BackupRecovery.vue?vue&type=template&id=30a35786&"
import script from "./BackupRecovery.vue?vue&type=script&lang=js&"
export * from "./BackupRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports